// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1JSdT","list":"styles_list__3GEh1"};